/** Returns the first non-empty string value, or an empty string. */
export const firstDefined = (...values: (string | null | undefined)[]) =>
  values.find((v) => v != null && v !== '') ?? ''

export const getRegionCountryCode = (
  countryCode?: string,
  fallback = ''
) => countryCode?.toUpperCase() || fallback
